import dynamic from 'next/dynamic';
import React from 'react';
import {
  CasinoCrashGameBox,
  CasinoCrashGameBoxItemLeft,
  CasinoCrashGameBoxItemRight,
  FeatureCasinoCrash,
  GameBoxWrapper,
  GameWrapper,
  SettingBoxConfig,
} from './styles';

import { Divider, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import BetBox from './BetBox';
import CrashMember from './GameBox/CrashMember';
import PreviourRoundResult from './GameBox/PreviourRoundResult';
import PlayerBox from './PlayerBox';
import SettingBox from '../game-settings';
import CrashGameInfo from './CrashGameInfo';
import GameRecommended from '@/components/features/common/GameRecommended';
import CrashCelebration from '@/components/features/casino/crash/CrashCelebration';

const GameBox = dynamic(() => import('./GameBox'), {
  ssr: false,
});

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface MoonGameProps {}
//
export const MoonGame: React.FC = (props: MoonGameProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <FeatureCasinoCrash>
      <CasinoCrashGameBox>
        <CasinoCrashGameBoxItemLeft>
          <GameWrapper>
            <PreviourRoundResult />
            <CrashMember />
            <GameBoxWrapper>
              <GameBox />
            </GameBoxWrapper>
            <CrashCelebration />
          </GameWrapper>
          <SettingBoxConfig>
            <BetBox />
          </SettingBoxConfig>
        </CasinoCrashGameBoxItemLeft>
        <CasinoCrashGameBoxItemRight>
          {isMobile && (
            <SettingBox
              isMob={isMobile}
              gameId={'crash'}
              fairnessLink={'/casino/fairness'}
            ></SettingBox>
          )}
          <PlayerBox />
        </CasinoCrashGameBoxItemRight>
      </CasinoCrashGameBox>
      {!isMobile && (
        <SettingBox
          isMob={isMobile}
          gameId={'crash'}
          fairnessLink={'/casino/fairness'}
        ></SettingBox>
      )}
      <CrashGameInfo />
      <GameRecommended />
      {/*<CrashBets />*/}
      <Divider sx={{ my: 4 }} />
      {/*<CrashBgSound />*/}
    </FeatureCasinoCrash>
  );
};

export default MoonGame;
